import {
  dispatchSiteEvent,
  siteEventNames,
} from './events/site-events';
/* 
  1 - Choose Swatches
*/
var ChooseSwatches = function ChooseSwatches() {
  var swatches = [];
  var submitBtn = $('.o-form__submit');
  var cartDiv = $('.c-cart');
  var cartMaxCt = window.cartMaxCt;
  var htmlHelpers = new HtmlHelpers();
  
  this.init = function() {
    // console.log('checkout.js, init');
    if (swatches.length === 0) {
      // If there are no swatches in swatchbook, the cart should definitely be empty.
      window.swatchbook.clearCart();
      disableSubmit();
      // Display messaging, hide cart
      $('.c-checkoutStepError__wrapper').removeClass('hidden');
      $('.c-checkoutStep__wrapper').addClass('hidden');
      return;
    }
    
    // Tidy up cart. Remove any swatches from cart that are no longer in swatchbook
    var isInBook;
    var cart = window.swatchbook.getSwatchbookData().cart;
    for (var i = 0; i < cart.length; i++) {
      isInBook = false;
      for (var j = 0; j < swatches.length; j++) {
        if (swatches[j]['swatch-id'] === cart[i]) {
          isInBook = true; // the swatch is in there, pass
        }
      }
      if (!isInBook) {
        window.swatchbook.removeSwatchFromCart(cart[i]);
      }
    }
    
    outputCartToPage();
    isCheckoutAvailable();
    
    // Add checkbox event listeners for add/remove to cart
    $('.o-form__checkbox input').on('change', function() {
      var id = parseInt($(this).attr('id'), 10);
      if ($(this).is(':checked')) {
        window.swatchbook.addSwatchToCart(id);
        updateItemLabel(this, true);
      } else {
        window.swatchbook.removeSwatchFromCart(id);
        updateItemLabel(this, false);
      }
      isCheckoutAvailable();    
    });   

    submitBtn.on('click', function() {
      if (window.useLocalStorage) {
        window.location = window.orderLoggedInUrl;
      } else if (window.isAuthenticated) {
        window.location = window.orderLoggedInUrl;
      } else {
        window.location = window.orderLoginUrl;
      }
    });
  };

  function updateItemLabel(item, checked) {
    var label = item.parentNode.querySelector('label');
    var colorName = label.getAttribute('data-colorname');
    var ariaLabel = '';
    if (checked) {
      ariaLabel = 'Remove ' + colorName + ' swatch from order';
    } else {
      ariaLabel = 'Add ' + colorName + ' swatch to order';
    }
    label.setAttribute('aria-label', ariaLabel);
  }

  function outputCartToPage() {
    // Add swatchbook to DOM 
    var checked, swatch, s = '';
    for (var i = 0; i < swatches.length; i++) {
      // If user is under max number swatches allowed, then check them all.
      // Otherwise only check swatches previously added to cart.
      checked = '';
      swatch = swatches[i];
      if (swatches.length <= cartMaxCt) {
        checked = 'checked';
        // Add to cart if swatch is not in there yet
        window.swatchbook.addSwatchToCart(swatch['swatch-id']);
      } else {
        var cart = window.swatchbook.getSwatchbookData().cart;
        if (cart.indexOf(swatch['swatch-id']) !== -1) {
          checked = 'checked';
        }
      }

      s += '<li class="c-cart__content"><div class="o-form__checkbox"><input type="checkbox" id="' + swatch['swatch-id'] +
          '" name="' + swatch['color-name'] + '" value="' + swatch['color-name'] + '" ' + checked + '>' +
          '<label for="' + swatch['swatch-id'] + '" class="o-checkboxLabel" data-colorname="' + swatch['color-name'] +
          '" aria-label="Remove ' + swatch['color-name'] + ' swatch from order"></label></div><div class="c-cart__image">' +
          '<img src="https://images.graberblinds.com/GraberBlindsImages/SwatchImages/' + swatch['large-image-path'] +
          '" alt=""></div><div class="c-cart__description"><p class="heading--sm">' + swatch['color-name'] +
          '</p><ul><li class="heading--xxs">' + swatch['color-number'] + '</li><li class="heading--xxs">' + swatch['collection-name'] +
          '</li><li class="body--small">' + swatch['style-title'] + '</li><li class="body--small">' + swatch['swatch-category-name'] +
          '</li></ul></div></li>';
    }
    cartDiv.append(s);
  }
  
  function isCheckoutAvailable() {
    var orderCt = document.querySelectorAll('.c-cart :checked').length;
    // console.log('checkout.js, isCheckoutAvailable, orderCt: ' + orderCt);
    if (orderCt > cartMaxCt || orderCt === 0) {
      disableSubmit();
    } else {
      enableSubmit();
    }
  }
  
  function disableSubmit() {
    submitBtn
      .addClass('o-form__submit--disabled')
      .prop('disabled', true);
  }
  
  function enableSubmit() {
    submitBtn
      .removeClass('o-form__submit--disabled')
      .prop('disabled', false);
  }

  if (window.isAuthenticated) {
    var that = this;
    // console.log('checkout.js, isAuthenticated: ' + window.isAuthenticated);
    disableSubmit();
    window.StorageActions.getItemsFromAccount('swatch', function(data) {
      // Only get swatches that have not already been ordered
      swatches = data.swatches;
      // console.log(swatches);
      that.init();
    });
  } else {
    swatches = swatchbook.getAllOfType('swatch');
    // Remap localstorage data...
    for (var i = 0; i < swatches.length; i++) {
      swatches[i] = htmlHelpers.remapLocalStorageProperties(swatches[i]);
    }
    this.init();
  }

  return this;
}
/*
  2 - Place Order
*/
var PlaceOrder = function PlaceOrder() {
  var swatches = [],
      cartDiv = $('.c-cart'),
      form = '#epiFormWrapper form',
      formBtn =  $(form + ' .o-form__submit'),
      cart = window.swatchbook.getSwatchbookData().cart,
      swatchCt = cart.length,
      cartMaxCt = window.cartMaxCt,
      custOrderNumber,
      htmlHelpers = new HtmlHelpers();

  this.init = function() {
    // Display messaging, hide cart if over swatch limit/no swatches in cart
    if (swatchCt > cartMaxCt || swatchCt === 0) {
      $('.c-checkoutStepError__wrapper').removeClass('hidden');
      if (swatchCt > cartMaxCt) {
        $('.c-checkoutStepError__wrapper .c-warning__overSwatchLimit').removeClass('hidden');
      } else if (swatchCt === 0) {
        $('.c-checkoutStepError__wrapper .c-warning__noSwatches').removeClass('hidden');
      }
      $('.c-checkoutStep__wrapper, .c-orderSummary').addClass('hidden');
      return;
    }
    // Add submit handler
    formBtn.on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      epiHelpers.disableSubmitButtonOnSend(formBtn);
      // Episerver validation
      if (epiHelpers.validateForm()) {
        window.announceMessage('Submitting order');
        placeOrder();
      } else {
        epiHelpers.reenableSubmitButton(formBtn);
        epiHelpers.scrollFormToFirstError();
      }
    });
    // Append cart to page
    if (!window.isAuthenticated) {
      cartDiv.append(htmlHelpers.outputSmallCartToPage(cart));
      htmlHelpers.setDataLayerSwatchProperties(cart);
    } else {
      window.StorageActions.getItemsFromAccount('swatch', function(data) {
        swatches = data.swatches;
        cartDiv.append(htmlHelpers.outputSmallCartToPage(cart, data.swatches));
        htmlHelpers.setDataLayerSwatchProperties(cart, swatches);
      });
    }
    // Convert password input type (if exist) to password
    epiHelpers.convertInputTypeToPassword();
    // Prepopulate data, if authenticated
    if (window.isAuthenticated) {
      window.swatchbook.getUserData(function(data) {
        mapUserDataToFormFields(data);
      });
    }
  };
  
  function mapUserDataToFormFields(data) {
    epiHelpers.getElementByMailchimpName('FNAME').val(data['first-name']);
    epiHelpers.getElementByMailchimpName('LNAME').val(data['last-name']);
    epiHelpers.getElementByMailchimpName('EMAIL').val(data['username']);
    epiHelpers.getElementByMailchimpName('PHONE').val(window.FormValidationUtils.formatPhone(data['phone-number']));
    epiHelpers.getElementByMailchimpName('ADDR_LINE1').val(data['address']);
    epiHelpers.getElementByMailchimpName('ADDR_LINE2').val(data['address2']);
    epiHelpers.getElementByMailchimpName('ADDR_CITY').val(data['city']);
    epiHelpers.getElementByMailchimpName('ADDR_STATE').val(data['state-or-province']);
    epiHelpers.getElementByMailchimpName('ADDR_ZIP').val(data['postal-code']);
    epiHelpers.getElementByMailchimpName('ADDR_CNTRY').val(data['country']);
  }

  function mapFormFieldsToSwfWebService() {
    var phone = getSeparatedPhoneVals(epiHelpers.getValByMailchimpField('PHONE'));
    // Can just use mailchimp attrs
    return JSON.stringify({
      "microsite-name": window.micrositeName,
      "first-name": epiHelpers.getValByMailchimpField('FNAME'),
      "last-name": epiHelpers.getValByMailchimpField('LNAME'),
      "phone-number-area-code": phone.areaCode,
      "phone-number-prefix": phone.prefix,
      "phone-number-line-number": phone.lineNumber,
      "email": epiHelpers.getValByMailchimpField('EMAIL'),
      "password": epiHelpers.getValByMailchimpField('PASSWORD'),
      "ship-to-address-line-1": epiHelpers.getValByMailchimpField('ADDR_LINE1'),
      "ship-to-address-line-2": epiHelpers.getValByMailchimpField('ADDR_LINE2'),
      "ship-to-city": epiHelpers.getValByMailchimpField('ADDR_CITY'),
      "ship-to-state": epiHelpers.getValByMailchimpField('ADDR_STATE'),
      "ship-to-zip-code": epiHelpers.getValByMailchimpField('ADDR_ZIP'),
      "ship-to-country": epiHelpers.getValByMailchimpField('ADDR_CNTRY'),
      "swatchlist": getSwatchesForOrder()
    });
  }

  function sendLeadToMailchimp() {
    var isBrandCommChecked = epiHelpers.getCheckedByMailchimpField('INTEREST_BRAND');
    var isDealerCommChecked = false;
    if (epiHelpers.getElementByMailchimpName('INTEREST_DEALER').length > 1) {
      // *NEW* Radio group, get selected value
      var selectedVal = epiHelpers.getCheckedRadioByMailchimpField('INTEREST_DEALER');
      if (selectedVal.indexOf('yes') != -1) {
        isDealerCommChecked = true;
      }
    }  else {
      isDealerCommChecked = epiHelpers.getCheckedByMailchimpField('INTEREST_DEALER');
    }
    if (isBrandCommChecked || isDealerCommChecked) {
      // console.log('checkout.js, sendLeadToMailchimp');
      epiHelpers.sendLeadToMailchimp();
    }
  }
  
  function sendLeadToGtm() {
    var eventLabel = '';
    if (epiHelpers.getElementByMailchimpName('INTEREST_DEALER').length > 1) {
      // *NEW* Radio group, get selected value
      eventLabel = epiHelpers.getCheckedRadioByMailchimpField('INTEREST_DEALER');
    } else {
      var isDealerCommChecked = epiHelpers.getCheckedByMailchimpField('INTEREST_DEALER');
      eventLabel = isDealerCommChecked ? 'yes' : 'no';
    }
    var optinLabel = epiHelpers.getCheckedRadioByMailchimpField('INTEREST_BRAND');
    dispatchSiteEvent(siteEventNames.ON_ORDER_SUBMITTED, {
      category: 'Swatch Lead',
      action: 'swatch-lead',
      label: eventLabel === 'yes',
      optin: optinLabel !== '',
      requestConsultation: eventLabel == 'yes',
      swatches:htmlHelpers.getDataLayerSwatchProperties(),
      value: '',
    });
  }

  function getSwatchesForOrder() {
    // console.log('checkout.js, getSwatchesForOrder');
    var arr = [];
    var swatch;
    for (var i = 0; i < cart.length; i++) {
      if (!window.isAuthenticated) {
        swatch = window.swatchbook.getItemById('sw-' + cart[i]);
        swatch = htmlHelpers.remapLocalStorageProperties(swatch);
      } else {
        swatch = htmlHelpers.getSwatchFromCartById(cart[i], swatches);
      }
      arr.push({
        'style-id' : swatch['style-id'],
        'swatch-category-id' : swatch['swatch-category-id'],
        'swatch-id' : swatch['swatch-id'],
        'microsite-name' : window.micrositeName,
        'country' : epiHelpers.getValByMailchimpField('ADDR_CNTRY')
      });
    }
    return arr;
  }

  function onPlaceOrderSuccess(data) {
    // console.log('checkout.js, placeOrder, onPlaceOrderSuccess');
    // Set customer order number
    custOrderNumber = data['order-number'];
    // Add order info to cookie
    createOrderObj();
    // Send lead to Mailchimp?
    sendLeadToMailchimp();
    // Send lead "...working with a dealer" to GTM
    sendLeadToGtm();
    // Add timer
    var redirectTimer = setTimeout(function() {
      clearTimeout(redirectTimer);
      // Navigate to confirmation page
      // Send to either Order Confirmation -OR- Order/Account Confirmation
      window.location = window.confirmationPage;
    }, 500);
  }

  function onPlaceOrderError(data) {
    // console.log('checkout.js, placeOrder, onPlaceOrderError');
    if (data['friendly-error-message'] === 'Username') {
      displayErrorMessage(window.checkoutEmailInUseErrorMsg);
      return;
    }
    displayErrorMessage(data['friendly-error-message']);
  }

  function placeOrder() {
    // console.log('checkout.js, placeOrder');
    var requestUrl = '/api/swatchpage/checkout';
    var request = new XMLHttpRequest();
    request.open('POST', requestUrl, true);
    request.setRequestHeader('Content-type', 'application/json');
    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {
        var data = JSON.parse(request.responseText);
        if (data.success) {
          onPlaceOrderSuccess(data);
        } else {
          onPlaceOrderError(data);
        }
      }
    };
    request.onerror = function() {
      var data = JSON.parse(request.responseText);
      displayErrorMessage(data);
    };
    request.send(JSON.stringify({
      data: mapFormFieldsToSwfWebService()
    }));
    // console.log(mapFormFieldsToSwfWebService());
  }

  function displayErrorMessage(msg) {
    epiHelpers.reenableSubmitButton(formBtn);
    $('#epiFormWrapper .Form__Errors .error-msg').text(msg)
    $('#epiFormWrapper .Form__Errors').removeClass('hidden');
    window.announceMessage('Error Submitting Form: ' + msg);
  }

  function getSeparatedPhoneVals(s) {
    var s = s.match(new RegExp(/\d/g) || [])
      s = s.join('');
    return {
      areaCode: s.substring(0,3),
      prefix: s.substring(3,6),
      lineNumber: s.substring(6)
    }
  }

  function createOrderObj() {
    var info = {
      orderNumber: custOrderNumber,
      data: JSON.parse(mapFormFieldsToSwfWebService())
    };
    // Set cookie
    ls.setItemInObj(ls.cookies.ordinfo, info);
    // console.log(info);
  }

  return this;
}
/*
  3 - Confirmation
*/
var Confirmation = function Confirmation() {
  
  var cartDiv = $('.c-cart'),
    addrDiv = $('.c-cart__shippingAddress'),
    orderNumDiv = $('#custOrderNumber'),
    emailDiv = $('#custEmail'),
    cart = window.swatchbook.getSwatchbookData().cart,
    htmlHelpers = new HtmlHelpers();
  
  this.init = function() {
    var data = ls.getItemFromObj(ls.cookies.ordinfo);
    let orderNumber = 'N/A';
    if (data) {
      orderNumber = data.orderNumber;
    }
    dispatchSiteEvent(siteEventNames.ON_ORDER_CONFIRMATION, {
      orderNumber,
      swatches:htmlHelpers.getDataLayerSwatchProperties(),
    });
    // Display messaging, hide cart
    if (data === undefined || data === null) {
      $('.c-checkoutStepError__wrapper').removeClass('hidden');
      $('.c-checkoutStep__wrapper, .c-orderSummary').addClass('hidden');
      return;
    }
    // Check order country and display corresponding status messaging
    if (data.data['ship-to-country'] === 'CA') {
      $('.c_orderStatusMsg--us').addClass('hidden');
      $('.c_orderStatusMsg--ca').removeClass('hidden');
    }
    addrDiv.append(htmlHelpers.outputOrderShippingSnippet(data));
    // Append cart to page
    if (!window.isAuthenticated) {
      cartDiv.append(htmlHelpers.outputSmallCartToPage(cart));
    } else {
      window.StorageActions.getItemsFromAccount('swatch', function(data) {
        cartDiv.append(htmlHelpers.outputSmallCartToPage(cart, data.swatches));
      });
    }
    orderNumDiv.text('#' + data.orderNumber);
    emailDiv.text(data.data['email']);
    // Clear order data after page loads/cart content in dom...
    window.swatchbook.clearOrderData();
    htmlHelpers.deleteDataLayerSwatchProperties()
  };
  
  return this;
}

var HtmlHelpers = function HtmlHelpers() {
  this.sessionStorageKey = '_swatchesInCart';

  this.createCartItemHtml = function(swatch) {
    return '<li class="c-cart__content"><div class="c-cart__image">' +
      '<img src="https://images.graberblinds.com/GraberBlindsImages/SwatchImages/' + swatch['large-image-path'] +
      '" alt="" /></div><div class="c-cart__description"><p class="heading--sm">' + swatch['color-name'] +
      '</p><p class="body--small">' + swatch['color-number'] + ' <span>&bull;</span> <span>' + swatch['collection-name'] +
      ' Collection</span></p><p class="body--small"><span>' + swatch['style-title'] +
      '</span></p><p class="body--small">' + swatch['swatch-category-name'] + '</p></div></li>';
  };
  
  this.remapLocalStorageProperties = function(swatch) {
    return {
      'category': swatch.category,
      'collection-name': swatch.collection,
      'color-name': swatch.colorName,
      'color-number': swatch.colorNumber,
      'large-image-path': swatch.imageUrl.substring(swatch.imageUrl.lastIndexOf('/')),
      'style-id': swatch.styleId,
      'style-title': swatch.productLine,
      'swatch-category-id': swatch.swatchCatId,
      'swatch-category-name': swatch.swatchCatName,
      'swatch-id': swatch.swatchId
    };
  };

  this.setDataLayerSwatchProperties = function(cart, swatches) {
    var swatchArr = [];
    var swatch = {};
    for (var i = 0; i < cart.length; i++) {
      if (!window.isAuthenticated) {
        swatch = window.swatchbook.getItemById('sw-' + cart[i]);
        swatch = this.remapLocalStorageProperties(swatch);
      } else {
        swatch = this.getSwatchFromCartById(cart[i], swatches);
        swatch.category = this.getSwatchCategoryForProduct(swatch);
      }
      swatchArr.push({
        item_category: 'Swatches',
        item_category2: swatch.category,
        item_id: swatch['swatch-id'],
        item_name: swatch['color-name'],
        price: 0,
        quantity: 1,
        swatch_category: swatch.category, 
        swatch_collection: swatch['collection-name'],
        swatch_color: swatch['color-name'],
        swatch_number: swatch['color-number'],
        swatch_product: swatch['product-line'],
        swatch_type: swatch['swatch-category-name'],
      });
    }
    // Add to session storage
    window.sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(swatchArr));
  };

  this.getDataLayerSwatchProperties = function() {
    // Pull from session storage
    var swatches = window.sessionStorage.getItem(this.sessionStorageKey);
    if (swatches) {
      return JSON.parse(swatches);
    }
    return [];
  };

  this.deleteDataLayerSwatchProperties = function() {
    // Remove from session storage
    window.sessionStorage.removeItem(this.sessionStorageKey);
  };

  this.getSwatchCategoryForProduct = function(swatch) {
    const product = swatch['product-line'].toLowerCase();
    if (product.indexOf('shades') !== -1 || product === 'sliding panels') {
      return 'Shades';
    } else if (product.indexOf('blinds') !== -1) {
      return 'Blinds';
    } else if (product.indexOf('drape') !== -1) {
      return 'Drapery';
    }
    return '';
  };
  
  this.getSwatchFromCartById = function(id, swatches) {
    for (var i = 0; i < swatches.length; i++) {
      if (id === swatches[i]['swatch-id']) {
        return swatches[i];
      }
    }
    return null;
  };

  this.outputSmallCartToPage = function(cart, swatches) {
    var that = this;
    var swatch;
    var s = '';
    for (var i = 0; i < cart.length; i++) {
      if (!window.isAuthenticated) {
        swatch = window.swatchbook.getItemById('sw-' + cart[i]);
        swatch = this.remapLocalStorageProperties(swatch);
      } else {
        swatch = that.getSwatchFromCartById(cart[i], swatches);
      }
      if (swatch !== null) {
        s += this.createCartItemHtml(swatch);
      }
    }
    return s;
  };

  this.outputOrderShippingSnippet = function(data) {
    var p1 = '<p>';
    var p2 = '</p>'
    var addr =  p1 + data.data['ship-to-address-line-1'] + p2;
    // Is address 2?
    if (data.data['ship-to-address-line-2'] !== '') {
      addr += p1 + data.data['ship-to-address-line-2'] + p2;
    }
    // Output
    return  p1 + data.data['first-name'] + ' ' + data.data['last-name'] + p2 +
        addr + 
        p1 + data.data['ship-to-city'] + ', ' + data.data['ship-to-state'] + ' ' + data.data['ship-to-zip-code'] + p2;
  };
}

// Set global vars
window.ChooseSwatches = ChooseSwatches;
window.PlaceOrder = PlaceOrder;
window.Confirmation = Confirmation;
